export default "__VITE_ASSET__BDo_HErl__"